import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { AiOutlineUser, AiOutlineHome } from 'react-icons/ai';
import { BiMessageSquareAdd } from 'react-icons/bi';
import { RiServiceLine } from 'react-icons/ri';
import { AiOutlineFolderOpen } from 'react-icons/ai';
import { FaBriefcase } from 'react-icons/fa';
import './Nav.css';

const navItems = [
  { id: 'home', href: '#home', Icon: AiOutlineHome, label: 'Home' },
  { id: 'about', href: '#about', Icon: AiOutlineUser, label: 'About' },
  { id: 'experience', href: '#experience', Icon: FaBriefcase, label: 'Experience' },
  { id: 'services', href: '#services', Icon: RiServiceLine, label: 'Services' },
  { id: 'portfolio', href: '#portfolio', Icon: AiOutlineFolderOpen, label: 'Portfolio' },
  { id: 'contact', href: '#contact', Icon: BiMessageSquareAdd, label: 'Contact' }
];

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = navItems.map((item) => document.getElementById(item.id));
      const scrollY = window.scrollY;
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section && section.offsetTop - 150 <= scrollY) {
          setActiveNav(`#${section.id}`);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="nav-bar-wrapper">
      <motion.nav
        className="nav-glass"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        {navItems.map(({ id, href, Icon, label }) => (
          <motion.a
            key={id}
            href={href}
            onClick={() => setActiveNav(href)}
            className={activeNav === href ? 'active' : ''}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            aria-label={label}
          >
            <Icon />
          </motion.a>
        ))}
      </motion.nav>
    </div>
  );
};

export default Nav;
